var _rect, _rect2, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.565478,
    y: 1.39165,
    width: 36.281,
    height: 36.281,
    rx: 18.1405,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.565478,
    y: 1.39165,
    width: 36.281,
    height: 36.281,
    rx: 18.1405,
    stroke: "#EFECE7",
    strokeWidth: 0.980566
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_303_1067",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.81152 19.5315L16.7441 12.5989L23.6768 19.5315L16.7441 26.4641L9.81152 19.5315Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6768 19.5315L25.0635 20.9182L26.4502 19.5315L25.0635 18.1448L23.6768 19.5315ZM15.3574 13.9856L22.29 20.9182L25.0635 18.1448L18.1309 11.2121L15.3574 13.9856ZM22.29 18.1448L15.3574 25.0774L18.1309 27.8508L25.0635 20.9182L22.29 18.1448Z",
    fill: "black",
    mask: "url(#path-2-inside-1_303_1067)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/rightArrowIcon.d47dfce229108e9636dff6e7a2362cc2.svg";
export { ForwardRef as ReactComponent };